import request from '@/utils/request';

export function ByteBanceAPI() {
    return {
        // 列表
        getTags: params => {
            return request({
                url: '/admin/bytedance/tags',
                method: 'get',
                params,
            });
        },
        fileDistributionUpload: data => {
            return request({
                url: '/admin/upload/distribution',
                method: 'post',
                data
            });
        },
        //新增
        WorksAdded: data => {
            return request({
                url: '/admin/novel/category/edit',
                method: 'post',
                data
            });
        },
        //小说审核结果
        getResults: params => {
            return request({
                url: '/admin/novel/get_audit_results',
                method: 'get',
                params
            });
        },
    };
}
